export function getCurrency() {
  // Forcing the use of Shopify's active currency
  if (window.GIFTBOX_USE_SHOPIFY_CURRENCY) {
    return window.Shopify.currency.active;
  }

  // https://apps.shopify.com/doubly-currency-converter
  const doublyCurrency =
    window.DoublyGlobalCurrency && window.DoublyGlobalCurrency.currentCurrency;
  if (doublyCurrency && doublyCurrency.length === 3) {
    return doublyCurrency;
  }

  // https://apps.shopify.com/currency-switcher
  const scmCurrency =
    window.SECOMAPP &&
    typeof window.SECOMAPP.cookie === 'function' &&
    window.SECOMAPP.cookie('scm_currency_2');
  if (scmCurrency && scmCurrency.length === 3) {
    return scmCurrency;
  }

  // https://apps.shopify.com/multi-currency
  const boldCurrency =
    window.BOLDCURRENCY && window.BOLDCURRENCY.currentCurrency;
  if (boldCurrency && boldCurrency.length === 3) {
    return boldCurrency;
  }

  // https://apps.shopify.com/coin
  const coinCurrency =
    window.Shoppad &&
    window.Shoppad.apps &&
    window.Shoppad.apps.coin &&
    typeof window.Shoppad.apps.coin.getLocalCurrency === 'function' &&
    window.Shoppad.apps.coin.getLocalCurrency();
  if (coinCurrency && coinCurrency.length === 3) {
    return coinCurrency;
  }

  // https://withreach.com/
  const reachCurrency = localStorage.getItem('GIP_USER_CURRENCY');
  if (reachCurrency && reachCurrency.length === 3) {
    return reachCurrency;
  }

  // https://apps.shopify.com/vitals
  const vitalsCurrency = localStorage.getItem('local_currency');
  if (vitalsCurrency && vitalsCurrency.length === 3) {
    return vitalsCurrency;
  }

  // https://apps.shopify.com/currency-converter-master
  try {
    const currencyLocationCustomer = localStorage.getItem(
      'autoketing-currency-location-customer-v1',
    );
    const autoketingCurrency =
      currencyLocationCustomer && JSON.parse(currencyLocationCustomer);
    if (autoketingCurrency && autoketingCurrency.length === 3) {
      return autoketingCurrency;
    }
  } catch (e) {
    console.error('JSON.parse error for: autoketingCurrency');
  }

  const currencyJs = window.Currency && window.Currency.currentCurrency;
  if (currencyJs && currencyJs.length === 3) {
    return currencyJs;
  }

  // https://apps.shopify.com/auto-multi-currency-converter
  const currencyBearJs = window.conversionBearAutoCurrencyConverter?.currency;
  if (currencyBearJs) {
    return currencyBearJs;
  }

  return window.Shopify.currency.active;
}

export function affixScriptToHead(url: string) {
  return new Promise((resolve, reject) => {
    var newScript = document.createElement('script');
    newScript.onerror = (oError) => {
      const target = (oError as Event).target as HTMLScriptElement;
      reject(
        new URIError('The script ' + target.src + " didn't load correctly."),
      );
    };
    newScript.onload = resolve;
    document.head.appendChild(newScript);
    newScript.src = url;
  });
}
